<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Права ролей"
        >
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-spacer />
                <v-dialog
                  v-model="dialog"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Новая запись
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span v-if="newItem" class="headline">Добавление Права</span>
                      <span v-if="!newItem" class="headline">Редактирование Права</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-text-field
                          v-model="editedItem.id"
                          label="Название роли"
                          disabled
                        />
                        <select-c :open-dialog="dialog" :select="editedItem.resources" :items="rightList" label="Ресурс" @selected="UpdateResurse" />
                        <v-select
                          v-model="editedItem.effect"
                          :items="effectList"
                          label="Тип разрешения"
                          single-line
                        />
                        <select-c :open-dialog="dialog" :select="editedItem.subjects" :items="roleList" label="Роли" @selected="UpdateSubjects" />
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.resources="{ item }">
              <v-chip
                v-for="r in item.resources"
                :key="r"
                outlined
                color="blue"
              >
                {{ r }}
              </v-chip>
            </template>
            <template v-slot:item.subjects="{ item }">
              <v-chip
                v-for="s in item.subjects"
                :key="s"
                outlined
                color="blue"
              >
                {{ s }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Rights, RightList, Roles, deleteRight, setRight } from '@/graphql/users'
import SelectC from '@/components/helper/select'
export default {
    layout: 'dashboard',
    name: 'RightsList',
    components: {
        SelectC
    },
    apollo: {
        Rights: {
           query: Rights,
           result ({ data, loading, networkStatus }) {
                this.data = data.Rights
                this.totalDesserts = this.data.length
                this.loading = false
            },
           update: data => data.Rights,
           deep: false
        },
        RightList: {
            query: RightList,
            result ({ data, loading, networkStatus }) {
                this.rightList = data.RightList
                this.loading = false
            },
           update: data => data.RightList,
           deep: false
        },
        Roles: {
            query: Roles,
            result ({ data, loading, networkStatus }) {
                for (const key in data.Roles) {
                    this.roleList.push(data.Roles[key].id)
                }
                this.loading = false
            },
            update: data => data.Roles,
            deep: false
        }
    },
     data () {
      return {
        newItem: true,
        dialog: false,
        data: [],
        options: {},
        totalDesserts: 0,
        loading: false,
        editedItem: {},
        rightList: [],
        effectList: ['allow', 'deny'],
        roleList: [],
        headers: [
          {
            sortable: false,
            text: 'ID',
            value: 'id'
          },
          {
            sortable: false,
            text: 'resources',
            value: 'resources'
          },
           {
            sortable: false,
            text: 'effect',
            value: 'effect'
          },
           {
            sortable: false,
            text: 'subjects',
            value: 'subjects'
          },
          { text: 'Actions', value: 'actions', sortable: false }
          ]
        }
    },
    watch: {
      dialog (val) {
        if (!val) {
          this.newItem = true
          this.editedItem = Object.assign({})
        }
      }
    },
     mounted () {
      this.$apollo.queries.Rights.refetch()
      this.$apollo.queries.RightList.refetch()
      this.$apollo.queries.Roles.refetch()
    },
     methods: {
         UpdateResurse (val) {
             this.editedItem.resources = val
         },
         UpdateEffect (val) {
             this.editedItem.effect = val
         },
         UpdateSubjects (val) {
             this.editedItem.subjects = val
         },
        editItem (item) {
          this.newItem = false
          this.editedItem = Object.assign({}, item)
           this.dialog = true
        },
        deleteItem (item) {
             this.$apollo.mutate({
                mutation: deleteRight,
                variables: {
                  id: item.id
                }
             }).then((data) => {
                  this.$apollo.queries.Rights.refetch()
              }).catch((error) => {
                console.error(error)
              })
        },
        close () {
          this.dialog = false
        },
        save () {
           this.$apollo.mutate({
                mutation: setRight,
                variables: {
                    id: this.editedItem.id,
                    resources: this.editedItem.resources,
                    effect: this.editedItem.effect,
                    subjects: this.editedItem.subjects
                }
             }).then((data) => {
                  this.$apollo.queries.Rights.refetch()
              }).catch((error) => {
                console.error(error)
              })

          this.close()
        }
      }
}
</script>

<style>

</style>
